const blinkCollections = [
    'amal-lawn',
    'premium-lawn-collection-2026'];

document.addEventListener('DOMContentLoaded', function () {
  blinkCollections?.forEach(handle => {
    const menuItems = document?.querySelectorAll(`.site-nav a[href="/collections/${handle}"],.site-nav summary[data-link="/collections/${handle}"]`);
    menuItems?.forEach(item => {
      if (item) {
        item.classList.add('blink-fade');
      }
    });
  });
});